module.exports = "/images/bannerFive.jpg";